/**
 * Scroll to a questionnaire preview anchor and run the flash animation
 * (styles in TemplatePreviewDrawer.css — import here so highlight works even if CSS load order varies).
 */
import '../../settings/template-library/components/TemplatePreviewDrawer.css';

const FLASH_REMOVE_MS = 1600;

export function scrollToAndFlashQuestionnaireItem(itemPath: string): boolean {
  const escaped =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape(itemPath)
      : itemPath.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const el = document.querySelector<HTMLElement>(`[data-item-path="${escaped}"]`);
  if (!el) return false;

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.remove('questionnaire-item-flash');
  void el.offsetWidth;
  el.classList.add('questionnaire-item-flash');
  window.setTimeout(() => el.classList.remove('questionnaire-item-flash'), FLASH_REMOVE_MS);
  return true;
}
